// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSourceValidation
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class DataSourceValidationBase {
  /** Do NOT invoke directly, instead use strongly typed createDataSourceValidationBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.DataSourceValidation";
  }
  initFromJson(json, deserializeContext) {
    this.initDataSourceValidation(json.dateRangeMax != null ? new Date(json.dateRangeMax) : null, json.dateRangeMin != null ? new Date(json.dateRangeMin) : null, json.expression != null ? json.expression : null, json.isWarning != null ? json.isWarning : null, json.maxLength != null ? json.maxLength : null, json.numDecimalPlaces != null ? json.numDecimalPlaces : null, json.patternMatch != null ? json.patternMatch : null, json.patternMatchDisplayMessage != null ? json.patternMatchDisplayMessage : null, json.patternMatchFlags != null ? json.patternMatchFlags : null, json.rangeMax != null ? json.rangeMax : null, json.rangeMin != null ? json.rangeMin : null, json.validValues != null ? TSOGUtils.decodeObjectArray(json.validValues, null, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "validValues")) : null);
  }
  initDataSourceValidation(dateRangeMax, dateRangeMin, expression, isWarning, maxLength, numDecimalPlaces, patternMatch, patternMatchDisplayMessage, patternMatchFlags, rangeMax, rangeMin, validValues) {
    this._dateRangeMax = dateRangeMax;
    this._dateRangeMin = dateRangeMin;
    this._expression = expression;
    this._isWarning = isWarning;
    this._maxLength = maxLength;
    this._numDecimalPlaces = numDecimalPlaces;
    this._patternMatch = patternMatch;
    this._patternMatchDisplayMessage = patternMatchDisplayMessage;
    this._patternMatchFlags = patternMatchFlags;
    this._rangeMax = rangeMax;
    this._rangeMin = rangeMin;
    this._validValues = validValues;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    if (this._dateRangeMax != null) {
      retVal["dateRangeMax"] = this._dateRangeMax;
    }
    if (this._dateRangeMin != null) {
      retVal["dateRangeMin"] = this._dateRangeMin;
    }
    if (this._expression != null) {
      retVal["expression"] = this._expression;
    }
    retVal["isWarning"] = this._isWarning;
    retVal["maxLength"] = this._maxLength;
    retVal["numDecimalPlaces"] = this._numDecimalPlaces;
    if (this._patternMatch != null) {
      retVal["patternMatch"] = this._patternMatch;
    }
    if (this._patternMatchDisplayMessage != null) {
      retVal["patternMatchDisplayMessage"] = this._patternMatchDisplayMessage;
    }
    if (this._patternMatchFlags != null) {
      retVal["patternMatchFlags"] = this._patternMatchFlags;
    }
    retVal["rangeMax"] = this._rangeMax;
    retVal["rangeMin"] = this._rangeMin;
    if (this._validValues != null) {
      retVal["validValues"] = TSOGUtils.toTSOGArray(this._validValues, serializeContext);
    }
    return retVal;
  }
  get dateRangeMax() {
    return this._dateRangeMax;
  }
  set dateRangeMax(value) {
    this._dateRangeMax = value;
  }
  get dateRangeMin() {
    return this._dateRangeMin;
  }
  set dateRangeMin(value) {
    this._dateRangeMin = value;
  }
  get expression() {
    return this._expression;
  }
  set expression(value) {
    this._expression = value;
  }
  get isWarning() {
    return this._isWarning;
  }
  set isWarning(value) {
    this._isWarning = value;
  }
  get maxLength() {
    return this._maxLength;
  }
  set maxLength(value) {
    this._maxLength = value;
  }
  get numDecimalPlaces() {
    return this._numDecimalPlaces;
  }
  set numDecimalPlaces(value) {
    this._numDecimalPlaces = value;
  }
  get patternMatch() {
    return this._patternMatch;
  }
  set patternMatch(value) {
    this._patternMatch = value;
  }
  get patternMatchDisplayMessage() {
    return this._patternMatchDisplayMessage;
  }
  set patternMatchDisplayMessage(value) {
    this._patternMatchDisplayMessage = value;
  }
  get patternMatchFlags() {
    return this._patternMatchFlags;
  }
  set patternMatchFlags(value) {
    this._patternMatchFlags = value;
  }
  get rangeMax() {
    return this._rangeMax;
  }
  set rangeMax(value) {
    this._rangeMax = value;
  }
  get rangeMin() {
    return this._rangeMin;
  }
  set rangeMin(value) {
    this._rangeMin = value;
  }
  get validValues() {
    return this._validValues;
  }
  set validValues(value) {
    this._validValues = value;
  }
}
//# sourceMappingURL=DataSourceValidationBase.js.map
